import React, {Component} from 'react';
import {connect} from 'react-redux';

class SelectRadioGroup extends Component {

    constructor(props) {
        super(props);
        this.renderInputs = this.renderInputs.bind(this);
    }

    renderInputs() {
        return this.props.configSelectRadioGroup.infoSelect.map((info, index) => {
            return (
                <div key={index} className={(this.props.configSelectRadioGroup.showLabel === false) ? "radio-filtro-input" : "" }>
                    <input type="radio" id={info.id} name={info.name} value={info.value}
                           onClick={(e) => this.props.configSelectRadioGroup.methodChange(info.value)}/>
                    <label htmlFor={info.id}>
                        <span className={info.icon}></span>
                        {info.label}
                    </label>
                </div>
            );
        });
    }

    render() {
        return (
            <div id={this.props.configSelectRadioGroup.idDiv} className={this.props.configSelectRadioGroup.classDiv}>
                { this.props.configSelectRadioGroup.showLabel &&
                    <label htmlFor={this.props.configSelectRadioGroup.mainId}>{this.props.configSelectRadioGroup.mainLabel}</label>
                }
                <div id={this.props.configSelectRadioGroup.mainId} className={"radio-group-toggle"}>
                    {this.renderInputs()}
                </div>
            </div>
        );
    }

    componentDidMount() {
        $("#" + this.props.configSelectRadioGroup.mainId + " input[value=" + (this.props.selected ?? this.props.configSelectRadioGroup.selected) + "]").prop("checked", true);
    }

    componentWillMount() {
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        $("#" + nextProps.configSelectRadioGroup.mainId + " input[value=" + (nextProps.configSelectRadioGroup.selected) + "]").prop("checked", true);
    }

}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default SelectRadioGroup
